import { Fragment, useContext, useEffect, useState } from 'react'
import ROLES_MAPPING, { ROLES } from 'core/constants/roles'
import { NavLink } from 'react-router'
import { hasPermission } from '../../../../../core/utils/hasPermission'
import FavoriteLink from './favoriteLink'
import { MenuContext } from '../menu'
import { useUserHasRoles } from 'core/hooks/useUserHasRoles'
import getRouteDisabled from './get-route-disabled'
import { useApiMenuGetUserPreferences } from '../../../../../core/api/menu/useApiMenuGetUserPreferences'
import { trackAnalyticsEvent } from '../../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const MenuAnimationsAccordion = ({ link, sublinks, url, isOpen }) => {
  const { t } = useTranslation()
  const isAdmin = useUserHasRoles([ROLES.ROLE_ADMIN])
  const { isEditing, selectedView, modifiedData } = useContext(MenuContext)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [isParentToRouteSelected, setIsParentToRouteSelected] = useState(false)
  const activeStyle = { color: '#0082c3' }
  const { data: user } = useApiMenuGetUserPreferences()

  useEffect(() => {
    setIsCollapsed(false)
    setIsParentToRouteSelected(false)
    sublinks.map(item => {
      if (item.path === url) {
        setIsCollapsed(true)
        setIsParentToRouteSelected(true)
      }
    })
  }, [isOpen])

  return (
    <div className={`mg-menu-animation-accordion ${isCollapsed ? 'isCollapsed' : ''}`}>
      <div
        className={`mg-menu-animation-accordion__text ${isParentToRouteSelected ? 'isParentToRouteSelected' : ''}`}
        onClick={() => {
          setIsCollapsed(!isCollapsed)
        }}
      >
        <div className="mg-menu-animation-accordion__text__title">
          <span className={`${link?.filled ? 'material-icons notranslate' : 'material-icons-outlined notranslate'}`}>
            {link.icon}
          </span>
          <span>{link?.name && t(link.name)}</span>
        </div>
        <span className="material-icons notranslate">chevron_right</span>
      </div>
      <div className="mg-menu-animation-accordion__sublinks">
        {sublinks.map(sublink => {
          if (!hasPermission(user.roles, ROLES_MAPPING, sublink.rights[0])) {
            return null
          }

          const actionGoogleAnalytics = `click_bottom_burger_menu_${sublink?.googleAnalyticsAction}`
          const isDisabledLink = getRouteDisabled(sublink?.id)
          const isNavigationDisabled = isEditing || (isDisabledLink && !isAdmin)
          const linkContent = (
            <div className="mg-menu-animation-accordion__sublinks__title__text">
              {sublink.path && <span>{t(sublink?.navigationMenuInformation?.menuName)}</span>}
              {isEditing && <FavoriteLink sublink={sublink} selectedView={selectedView} modifiedData={modifiedData} />}
            </div>
          )
          return (
            <Fragment key={sublink.id}>
              {isNavigationDisabled ? (
                <div className={`mg-menu-animation-accordion__sublinks__title ${isDisabledLink ? 'disabled' : ''}`}>
                  {linkContent}
                </div>
              ) : (
                <NavLink
                  to={sublink.path}
                  className={`mg-menu-animation-accordion__sublinks__title ${isDisabledLink ? 'disabled' : ''}`}
                  onClick={() => {
                    trackAnalyticsEvent(actionGoogleAnalytics)
                  }}
                  style={({ isActive }) => (isActive ? activeStyle : undefined)}
                  end
                >
                  {linkContent}
                </NavLink>
              )}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default MenuAnimationsAccordion
